'use client';
import { memo, useEffect } from 'react';

const Datadog = memo(() => {
    const initDD = () => {
        if (window.DD_RUM) window.DD_RUM.startSessionReplayRecording();
    };

    useEffect(() => {
        initDD();
    }, []);

    return <></>;
});

export default Datadog;
